import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgLinkedinIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M1.401.121A2.116 2.116 0 0 0 .19 1.25l-.115.287v23.937l.115.287c.196.424.52.775.928 1.003l.317.172h24.19l.312-.172c.395-.215.714-.548.912-.952l.136-.288V1.487l-.136-.288a2.268 2.268 0 0 0-.922-.967l-.303-.156-12.019-.01C3.805.056 1.552.066 1.401.12Zm5.296 3.704c.395.112.749.336 1.018.645.282.27.48.614.575.993.11.464.085.95-.07 1.4a2.313 2.313 0 1 1-1.523-3.038Zm12.79 6.082c.227.04.605.142.842.227 1.436.52 2.202 1.593 2.565 3.598.11.59.11.7.11 4.939v4.334h-3.98l-.03-3.931c-.026-3.578-.036-3.956-.116-4.233a2.318 2.318 0 0 0-.57-1.038c-.328-.303-.61-.408-1.184-.439-1.124-.055-1.814.293-2.207 1.124-.323.69-.323.68-.353 4.788l-.025 3.729h-3.982l-.015-6.44-.01-6.436h3.88v1.79l.137-.202a4.383 4.383 0 0 1 2.973-1.885c.423-.06 1.41-.02 1.965.075ZM8.053 16.564l-.015 6.44H4.057l-.015-6.44-.01-6.435h4.031l-.01 6.435Zm21.24 7.146c-.203.099-.39.232-.548.393a1.864 1.864 0 0 0 .332 2.752c.347.237.767.342 1.184.297a1.83 1.83 0 0 0 .66-3.452c-.216-.116-.337-.14-.76-.156-.5-.02-.51-.015-.867.166Zm1.462.141c.357.159.648.435.827.782.12.241.14.352.14.69 0 .337-.024.453-.135.69a1.638 1.638 0 0 1-2.963.015 1.915 1.915 0 0 1-.02-1.34c.387-.837 1.34-1.21 2.151-.837Z"
      fill="currentColor"
    />
    <path
      d="M29.48 25.348v.957h.126c.126 0 .126-.005.126-.428v-.428h.172c.156 0 .186.03.438.428.237.373.287.428.413.428.162 0 .172.03-.171-.488l-.242-.358.136-.035c.328-.081.484-.419.343-.746-.101-.242-.227-.287-.842-.287h-.499v.957Zm1.018-.67c.05.045.091.151.091.247 0 .237-.146.322-.54.322h-.317v-.655h.338c.242 0 .363.025.428.086Z"
      fill="currentColor"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgLinkedinStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgLinkedinIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const LinkedinIcon: any = SvgLinkedinStyle;
export default LinkedinIcon;
